import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'Textarea',
  props: {
    modelValue: {},
    class: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    value: __props.modelValue,
    class: _normalizeClass(_unref(cn)('ui-textarea', props.class)),
    onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)))
  }, null, 42, _hoisted_1))
}
}

})